module.exports = __webpack_public_path__ + "img/logoTwo.7819f0de.png";